import { AirportSearchViewModel } from '@api/index';
import { LocationPinIcon, PlaneIcon } from '@assets/icons';
import { FlexibleDiv } from '@components/formStyles';
import {
  ItemText,
  ItemTextWrapper,
} from '@components/ui/search/SearchResultListStyle';
import CustomIcon from '@components/utils/CustomIcon';
import { useAirportSearchGet } from '@components/views/flight/hooks/flight.query';
import { AirportSearchResultListProps } from '@components/views/flight/types';
import {
  getAirportListItemSubTitleText,
  getAirportListItemTitleText,
} from '@components/views/flight/utils';

import {
  AirportCity,
  AirportList,
  AirportListItem,
} from './SearchBarAirportSearchStyle';
import { ItemErrorText } from './styled';

const AirportSearchResultList: React.FC<AirportSearchResultListProps> = ({
  searchText,
  onSelect,
  shouldFilterCities = false,
}) => {
  const {
    data = [],
    isLoading,
    isFetched,
  } = useAirportSearchGet({
    airportName: searchText,
    select: (airports) => {
      return shouldFilterCities
        ? airports.filter(({ isCity }) => !isCity)
        : airports;
    },
  });

  return Array.isArray(data) && data?.length ? (
    <AirportList
      dataSource={data}
      rowKey={() => 'airportId'}
      loading={isLoading}
      bordered={false}
      renderItem={(item: AirportSearchViewModel) => (
        <AirportListItem onClick={() => onSelect(item)}>
          <CustomIcon
            width={24}
            height={24}
            fontSize={24}
            paletteColor='primaryBrand'
            icon={item.isCity ? LocationPinIcon : PlaneIcon}
          />
          <FlexibleDiv right={17} />
          <ItemTextWrapper>
            <ItemText>
              <AirportCity>{getAirportListItemTitleText(item)}</AirportCity>
            </ItemText>
            <AirportCity>{getAirportListItemSubTitleText(item)}</AirportCity>
          </ItemTextWrapper>
        </AirportListItem>
      )}
    />
  ) : isFetched && !isLoading && searchText && searchText?.length > 2 ? (
    <ItemErrorText>Aradığınız kriterlere uygun sonuç bulunamadı.</ItemErrorText>
  ) : null;
};

export default AirportSearchResultList;
